<template>
  <div>
    <div class="flex flex-wrap mb-3">
      <div class="w-full flex flex-wrap justify-center">
        <div class="flex items-center w-3/5 sm:w-2/5 lg:w-1/5 ">
          <label class="w-1/4 block font-bold text-tiny">Year :</label>
          <div class="relative w-1/2 border-none max-h-9">
            <select v-model="selectedYear" @change="getData()" class="text-black-400 border border-black-500  inline-block py-2 pl-3 pr-8 rounded leading-tight w-full">
              <option v-for="year in years" :value="year">
                {{ year }}
              </option>
            </select>
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
              <i class="fas fa-chevron-down text-gray-400"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="div-title uppercase text-center pb-3.5 border-b border-b-gray-200 mb-8">
      <h1 class="text-4xl">
        photo galleries
      </h1>
    </div>

    <div class="container mx-auto">
      <div class="gallery-info flex capitalize justify-end mb-5 text-tiny text-gray-500">
        <span class="nr mr-1">{{ count_albums }} </span>
        <p>Total Photo Galleries</p>
<!--        <div class="flex ml-2" id="viewcontrols">-->
<!--          <p class="mr-2">View:</p>-->
<!--          <div @click="show=false" class="gridview lowercase" :class="{ 'text-darkRed': show === false }">grid</div>-->
<!--          <span class="text-gray-400 px-1">|</span>-->
<!--        </div>-->
      </div>

      <template v-if="ready">
        <div class="grid-layout">
          <div class="click grid-cols-1 grid sm:grid-cols-2  md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-4">
            <div v-for="(album,index) in albums" class="card-gallery">
              <div class="box-img mb-4">
                <NuxtLink :to="'/photo-gallery/photos/'+album.path" :aria-label="album.name">
                  <template v-if="index<1">
                    <nuxt-img
                        preload
                        format="webp"
                        rel="preload"
                        class="mx-auto"
                        :src="album.cover_photo? siteURL + '/storage/images/gallery/'+album.path+'/cover/'+album.cover_photo:'/no_image_album.jpg'"
                        :alt="album.name"
                        width="165"
                        height="90"/>
                  </template>
                  <template v-else>
                    <nuxt-img
                        loading="lazy"
                        format="webp"
                        class="mx-auto"
                        :src="album.cover_photo? siteURL + '/storage/images/gallery/'+album.path+'/cover/'+album.cover_photo:'/no_image_album.jpg'"
                        :alt="album.name"
                        width="165"
                        height="90"/>
                  </template>

                </NuxtLink>
              </div>
              <div class="flex flex-col">
                <div class="list-box">
                  <h2 class="custom-h2 text-center leading-4 mb-2.5">
                    <NuxtLink :to="'/photo-gallery/photos/'+album.path" class="underline mb-2.5 font-medium text-tiny text-gray-600" >{{album.name}}</NuxtLink>
                  </h2>
<!--                  <div class="items text-center text-tiny text-neutral-800">-->
<!--                  <span class="number">-->
<!--                    {{album.images_count}}-->
<!--                  </span>-->
<!--                    items-->
<!--                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
<!--        <div v-if="show" class="click list-layout">-->
<!--          <div class="flex flex-row flex-wrap">-->
<!--            <div v-for="(album,index) in albums" class="w-full md:w-1/2 flex">-->
<!--              <div class="box-img md:mb-4 w-2/6 md:w-2/5 mb-2">-->
<!--                <template v-if="index<1">-->
<!--                  <nuxt-img-->
<!--                      preload-->
<!--                      format="webp"-->
<!--                      rel="preload"-->
<!--                      class="mx-auto"-->
<!--                      :src="album.cover_photo? siteURL + '/storage/images/gallery/'+album.path+'/cover/'+album.cover_photo:'/no_image_album.jpg'"-->
<!--                      :alt="album.name"-->
<!--                      width="204" height="112"/>-->
<!--                </template>-->
<!--                <template v-else>-->
<!--                  <nuxt-img-->
<!--                      loading="lazy"-->
<!--                      format="webp"-->
<!--                      class="mx-auto"-->
<!--                      :src="album.cover_photo? siteURL + '/storage/images/gallery/'+album.path+'/cover/'+album.cover_photo:'/no_image_album.jpg'"-->
<!--                      :alt="album.name"-->
<!--                      width="204" height="112"/>-->
<!--                </template>-->
<!--              </div>-->
<!--              <div class="flex flex-col w-4/6 md:w-2/4 p-2">-->
<!--                <div class="list-box">-->
<!--                  <h2 class="custom-h2 leading-4 mb-0.5 sm:mb-2.5">-->
<!--                    <NuxtLink :to="'/photo-gallery/photos/'+album.path" class="underline mb-0.5 sm:mb-2.5 font-medium text-tiny text-gray-600">{{album.name}}</NuxtLink>-->
<!--                  </h2>-->
<!--                  <div class="added">-->
<!--                    Added On:-->
<!--                    <span class="date">{{album.album_date}}</span>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </template>
      <template v-else v-for="n in 5" :key="n">
        <GalleryLoader />
      </template>
    </div>
  </div>
</template>

<script setup>
import {http} from "~/utils/http";
import {useSiteURL} from "~/composables/state";
import {ref} from "vue";

const albums = ref([]);
const years = ref([]);
const count_albums = ref('0');
let selectedYear = ref('0');
let show = ref(false);
const ready = ref(false);
const siteURL = useSiteURL();

async function getData () {
  try {
    ready.value = false;
    await http
        .get("/api/gallery",{
          params: {
            year: selectedYear.value,
          },
        })
        .then((response) => {
          albums.value = response.data.albums;
          years.value = response.data.years;
          selectedYear.value =  response.data.currentYear;
          count_albums.value =  response.data.count_albums;
          ready.value = true;
        });
  } catch (e) {
    console.log(e.response.data.error);
  }
}

getData();

</script>
